import React, { Component } from 'react';
import { Link, Redirect } from 'react-router-dom';
import Select from 'react-select';
import './AlumnoForm.css';
import './MDAlumnos.css';
import * as constantClass from '../fileWithConstants';
import { isSubmitInProgress } from '../../services/formSubmitGuard';
import { SELECT_LABELS, selectPlaceholder, withSelectPlaceholder } from '../../services/selectOptions';

const PAPELES_OPTIONS = withSelectPlaceholder(
  [
    { value: 'S', label: 'Sí' },
    { value: 'N', label: 'No' },
  ],
  SELECT_LABELS.papelesCompletos
);

const PAGO_OPTIONS = withSelectPlaceholder(
  [
    { value: 'S', label: 'Sí' },
    { value: 'N', label: 'No' },
  ],
  'Seleccione si pagó la inscripción'
);

const SELECT_CLASS_NAMES = {
  control: () => 'md-form-page__select__control',
};

function BackIcon() {
  return (
    <svg className="md-page__icon md-page__icon--sm" viewBox="0 0 24 24" aria-hidden="true">
      <path d="M19 12H5M12 19l-7-7 7-7" />
    </svg>
  );
}

function formatSiNoLabel(value) {
  if (value === 'S' || value === true) return 'Sí';
  if (value === 'N' || value === false) return 'No';
  return value || '—';
}

function formatPapelesLabel(value) {
  return formatSiNoLabel(value);
}

export class UpdateAlumno extends Component {
  static displayName = UpdateAlumno.name;

  constructor(props) {
    super(props);
    this.state = {
      loadingInitial: true,
      loading: false,
      loadError: '',
      dni: '',
      name: '',
      papelesCompletos: 'N',
      valuePapeles: selectPlaceholder(SELECT_LABELS.papelesCompletos),
      pagoInscripcion: 'N',
      valuePago: selectPlaceholder('Seleccione si pagó la inscripción'),
      errorMessage: '',
      redirect: false,
      id: this.props.match.params.id,
      details: this.props.match.params.details,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleDNIChangeInput = this.handleDNIChangeInput.bind(this);
    this.handleNameChangeInput = this.handleNameChangeInput.bind(this);
    this.handlePapelesChange = this.handlePapelesChange.bind(this);
    this.handlePagoChange = this.handlePagoChange.bind(this);
  }

  get isReadOnly() {
    return this.state.details === '1';
  }

  componentDidMount() {
    const canAccess = constantClass.canAccess('WWAlumnos');
    if (canAccess) {
      this.populateData();
    } else {
      this.setState({ loadingInitial: false });
    }
  }

  clearFeedback() {
    if (this.state.errorMessage) {
      this.setState({ errorMessage: '' });
    }
  }

  handleDNIChangeInput(e) {
    this.clearFeedback();
    this.setState({ dni: e.target.value });
  }

  handleNameChangeInput(e) {
    this.clearFeedback();
    this.setState({ name: e.target.value });
  }

  handlePapelesChange(option) {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    this.setState({
      valuePapeles: option,
      papelesCompletos: value,
    });
  }

  handlePagoChange(option) {
    this.clearFeedback();
    const value = option && option.value ? option.value : '';
    this.setState({
      valuePago: option,
      pagoInscripcion: value,
    });
  }

  isFormValid() {
    return this.state.dni.trim().length > 0 && this.state.name.trim().length > 0;
  }

  handleSubmit(e) {
    e.preventDefault();
    if (this.isReadOnly) {
      this.setState({ redirect: true });
      return;
    }
    if (isSubmitInProgress(this.state.loading)) {
      return;
    }
    if (!this.isFormValid()) {
      this.setState({ errorMessage: 'Los campos Documento y Nombre son obligatorios.' });
      return;
    }
    if (!this.state.papelesCompletos) {
      this.setState({ errorMessage: 'Seleccione si los papeles están completos.' });
      return;
    }
    if (!this.state.pagoInscripcion || (this.state.pagoInscripcion !== 'S' && this.state.pagoInscripcion !== 'N')) {
      this.setState({ errorMessage: 'Seleccione si pagó la inscripción.' });
      return;
    }
    this.saveStudent();
  }

  async populateData() {
    this.setState({ loadingInitial: true, loadError: '' });

    const { data } = await constantClass.apiFetch('api/Students/' + this.state.id, {
      method: 'GET',
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || !data.returnModel) {
      this.setState({
        loadingInitial: false,
        loadError: constantClass.getApiErrorMessage(
          data,
          'No se pudieron cargar los datos del alumno.'
        ),
      });
      return;
    }

    const model = data.returnModel;
    const papeles = (model.alumnoPapelesCompletos || 'N').toString().trim();
    const selectedPapeles =
      PAPELES_OPTIONS.find((x) => x.value === papeles) ||
      PAPELES_OPTIONS.find((x) => x.value === 'N');
    const pago = model.alumnoPagoInscripcion ? 'S' : 'N';
    const selectedPago =
      PAGO_OPTIONS.find((x) => x.value === pago) ||
      PAGO_OPTIONS.find((x) => x.value === 'N');

    this.setState({
      loadingInitial: false,
      dni: model.alumnoDni || '',
      name: model.alumnoNombre || '',
      papelesCompletos: papeles,
      valuePapeles: selectedPapeles,
      pagoInscripcion: pago,
      valuePago: selectedPago,
    });
  }

  async saveStudent() {
    if (isSubmitInProgress(this.state.loading)) {
      return;
    }

    const dni = this.state.dni.trim();
    const name = this.state.name.trim();

    this.setState({ loading: true, errorMessage: '' });

    const { data } = await constantClass.apiFetch('api/Students/', {
      method: 'POST',
      body: JSON.stringify({
        AlumnoNombre: name,
        AlumnoDni: dni,
        AlumnoCodigo: parseInt(this.state.id, 10),
        AlumnoPapelesCompletos: this.state.papelesCompletos,
        AlumnoPagoInscripcion: this.state.pagoInscripcion === 'S',
      }),
    });

    if (data === 'Timeout') {
      constantClass.RedirectToLogin();
      return;
    }

    if (constantClass.isApiError(data) || data.returnModel === false) {
      this.setState({
        loading: false,
        errorMessage: constantClass.getApiErrorMessage(
          data,
          'No se pudo actualizar el alumno. Verifique los datos e intente nuevamente.'
        ),
      });
      return;
    }

    this.setState({ loading: false, redirect: true });
  }

  renderLoading() {
    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-alumnos">
          <BackIcon />
          Volver al listado
        </Link>
        <h1 className="md-form-page__title">
          {this.isReadOnly ? 'Detalle del Alumno' : 'Modificar Alumno'}
        </h1>
        <p className="md-form-page__skeleton">
          <em>Cargando datos del alumno...</em>
        </p>
      </div>
    );
  }

  renderLoadError() {
    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-alumnos">
          <BackIcon />
          Volver al listado
        </Link>
        <h1 className="md-form-page__title">
          {this.isReadOnly ? 'Detalle del Alumno' : 'Modificar Alumno'}
        </h1>
        <div className="md-page__error" role="alert">
          {this.state.loadError}
        </div>
        <div className="md-form-page__actions">
          <button
            type="button"
            className="md-form-page__btn md-form-page__btn--secondary"
            onClick={() => this.populateData()}
          >
            Reintentar
          </button>
          <Link className="md-form-page__btn md-form-page__btn--primary" to="/md-alumnos">
            Volver al listado
          </Link>
        </div>
      </div>
    );
  }

  render() {
    if (this.state.redirect) {
      return <Redirect to="/md-alumnos" />;
    }

    if (this.state.loadingInitial) {
      return this.renderLoading();
    }

    if (this.state.loadError) {
      return this.renderLoadError();
    }

    const { loading, dni, name, errorMessage, valuePapeles, papelesCompletos, valuePago, pagoInscripcion } = this.state;
    const isBusy = loading;
    const readOnly = this.isReadOnly;
    const title = readOnly ? 'Detalle del Alumno' : 'Modificar Alumno';
    const subtitle = readOnly
      ? 'Consulte los datos registrados del alumno.'
      : 'Actualice el documento, nombre, papeles o pago de inscripción del alumno.';

    return (
      <div className="md-page md-form-page">
        <Link className="md-form-page__back" to="/md-alumnos">
          <BackIcon />
          Volver al listado
        </Link>

        <h1 className="md-form-page__title">{title}</h1>
        <p className="md-form-page__subtitle">{subtitle}</p>

        <div className="md-form-page__card">
          <form className="md-form-page__form" onSubmit={this.handleSubmit} noValidate>
            <div className="md-form-page__feedback" aria-live="polite" role="status">
              {errorMessage ? <span className="md-form-page__error">{errorMessage}</span> : null}
              {!readOnly && loading ? (
                <span className="md-form-page__loading">Guardando cambios, espere un momento...</span>
              ) : null}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="alumno-dni-edit">
                Documento de Identidad
              </label>
              <input
                id="alumno-dni-edit"
                className="md-form-page__input"
                type="text"
                name="dni"
                autoComplete="off"
                placeholder="Ingrese DNI"
                value={dni}
                onChange={this.handleDNIChangeInput}
                disabled={isBusy || readOnly}
                readOnly={readOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="alumno-nombre-edit">
                Nombre Completo
              </label>
              <input
                id="alumno-nombre-edit"
                className="md-form-page__input"
                type="text"
                name="name"
                autoComplete="off"
                placeholder="Ingrese nombre y apellido"
                value={name}
                onChange={this.handleNameChangeInput}
                disabled={isBusy || readOnly}
                readOnly={readOnly}
                required
              />
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="alumno-papeles">
                Papeles Completos
              </label>
              {readOnly ? (
                <input
                  id="alumno-papeles"
                  className="md-form-page__input"
                  type="text"
                  value={formatPapelesLabel(papelesCompletos)}
                  readOnly
                  disabled
                />
              ) : (
                <div className="md-form-page__select-wrap">
                  <Select
                    inputId="alumno-papeles"
                    classNamePrefix="md-form-page__select"
                    classNames={SELECT_CLASS_NAMES}
                    value={valuePapeles}
                    options={PAPELES_OPTIONS}
                    onChange={this.handlePapelesChange}
                    isDisabled={isBusy}
                    isSearchable={false}
                  />
                </div>
              )}
            </div>

            <div className="md-form-page__field">
              <label className="md-form-page__label" htmlFor="alumno-pago-inscripcion">
                Pago de Inscripción
              </label>
              {readOnly ? (
                <input
                  id="alumno-pago-inscripcion"
                  className="md-form-page__input"
                  type="text"
                  value={formatSiNoLabel(pagoInscripcion)}
                  readOnly
                  disabled
                />
              ) : (
                <div className="md-form-page__select-wrap">
                  <Select
                    inputId="alumno-pago-inscripcion"
                    classNamePrefix="md-form-page__select"
                    classNames={SELECT_CLASS_NAMES}
                    value={valuePago}
                    options={PAGO_OPTIONS}
                    onChange={this.handlePagoChange}
                    isDisabled={isBusy}
                    isSearchable={false}
                  />
                </div>
              )}
            </div>

            {!readOnly ? (
              <div className="md-form-page__actions">
                <button
                  type="submit"
                  className="md-form-page__btn md-form-page__btn--primary"
                  disabled={isBusy}
                >
                  Guardar cambios
                </button>
              </div>
            ) : null}
          </form>
        </div>
      </div>
    );
  }
}
